
import { Box, styled } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import Footers from './Footers';
import { useChatContex } from '../../../contex/ChatContex';
import { GetMessage, SendMessage } from '../../../server/Server';
import Messagesess from './Messagesess';
import Conversation from '../menu/Conversation';




const Wrapper=styled(Box)`
background-image: url(${'https://user-images.githubusercontent.com/15075759/28719144-86dc0f70-73b1-11e7-911d-60d70fcded21.png'});
background-size: 50%;
`
const Component = styled(Box)`
    height: 80vh;
    overflow-y: scroll;
`;

const Container=styled(Box)`
padding:1px 80px;
`



function Messaage() {


const{login, PersonData,Convesation,ConverSationData,socket,Sette,te}=useChatContex()

 const[text,SetText]=useState('')


 const[mesaage,setMessage]=useState([])
 const[file,SetFile]=useState()
 const[image,SetImage]=useState('')
 const[incomingmessage,setincommingmessage]=useState(null)
 
 const scrollRef = useRef();


 useEffect(()=>{
    socket.current.on('getMessage',data=>{
        setincommingmessage({
            ...data,
            createdAt:Date.now()
        })
    })
 },[text])



useEffect(()=>{
    incomingmessage && Convesation?.members.includes(incomingmessage.senderId) &&
    setMessage(pre=>[...pre,incomingmessage])
},[incomingmessage,Conversation])


 useEffect(() => {
    scrollRef.current?.scrollIntoView({ transition: "smooth" })
}, [mesaage]);




    const SentKeys=(e)=>{

      const code=e.keyCode || e.which;
      if(code==13){
         let message ={}
        if(!file){
             message={
                senderId:login.sub,
                ReceivedId: PersonData.sub,
                conversationId:Convesation._id,
                type:"text",
                text:text
    
            }
        }
            else{
                 message={
                    senderId:login.sub,
                    ReceivedId: PersonData.sub,
                    conversationId:Convesation._id,
                    type:"file",
                    text:image
        
            }


        }

        
       socket.current.emit('sendMessage',message)
        
        SendMessage(message)


        SetText('')
        Sette(prev=>!prev)
        SetFile('')
        SetImage('')

      }
    }



useEffect(()=>{
   const get=async()=>{
      const data= await GetMessage(Convesation._id)
     // console.log(data)
        setMessage(data)
        
   }
  get()
},[PersonData,te])

    return (
        <Wrapper>
            <Component>
            {
                mesaage && mesaage.map(mesage=>(
                    <Container ref={scrollRef}>
                       <Messagesess   mesage={mesage} />
                    </Container>
                ))
            }
               
            </Component>
            <Footers SentKeys={SentKeys} SetText={SetText} text={text} file={file} SetFile={SetFile} SetImage={SetImage} />
        </Wrapper>
    )
}

export default Messaage
